import { render, staticRenderFns } from "./couseRecord.vue?vue&type=template&id=10ec64e7&scoped=true"
import script from "./couseRecord.vue?vue&type=script&lang=js"
export * from "./couseRecord.vue?vue&type=script&lang=js"
import style0 from "./couseRecord.vue?vue&type=style&index=0&id=10ec64e7&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec64e7",
  null
  
)

export default component.exports